import { defineCatalogue } from '../../../i18n';

export const adversariesCatalogue = defineCatalogue(
  {
    title: 'Adversários',
    subtitle: 'Alcance, engajamento e comentários das contas adversárias, ao lado das próprias.',

    'window.label': 'Período',
    'window.7d': 'Últimos 7 dias',
    'window.14d': 'Últimos 14 dias',
    'window.30d': 'Últimos 30 dias',

    'chart.reachSentiment.title': 'Alcance e sentimento por conta',
    'chart.reachSentiment.aria': 'Alcance e sentimento médio, por conta',
    'chart.reach.label': 'Alcance',
    'chart.sentiment.label': 'Sentimento médio',

    'chart.reachOverTime.title': 'Alcance diário por conta',
    'chart.reachOverTime.aria': 'Alcance diário, uma linha por conta',

    'table.title': 'Contas no período',
    'table.account': 'Conta',
    'table.alignment': 'Alinhamento',
    'table.alignment.own': 'Própria',
    'table.alignment.adversary': 'Adversária',
    'table.posts': 'Publicações',
    'table.reach': 'Alcance',
    'table.engagement': 'Engajamento',
    'table.targeting': 'Publicações contra nós',
    'table.commentsRead': 'Comentários analisados',
    'table.sentiment': 'Sentimento médio',
    'table.unknownHandle': 'Conta sem usuário',
    'table.candidate.unassigned': 'Sem candidato marcado',

    'empty.title': 'Nenhuma conta adversária monitorada.',
    'empty.description':
      'Marque uma conta com o alinhamento Adversária para compará-la com a campanha.',

    'error.title': 'Erro ao carregar Adversários',
    'error.description': 'Não foi possível carregar a leitura das contas no período.',
    loading: 'Carregando Adversários...',
  },
  {
    title: 'Adversaries',
    subtitle: 'Reach, engagement and comments on adversary accounts, alongside your own.',

    'window.label': 'Window',
    'window.7d': 'Last 7 days',
    'window.14d': 'Last 14 days',
    'window.30d': 'Last 30 days',

    'chart.reachSentiment.title': 'Reach and sentiment per account',
    'chart.reachSentiment.aria': 'Reach and average sentiment, per account',
    'chart.reach.label': 'Reach',
    'chart.sentiment.label': 'Average sentiment',

    'chart.reachOverTime.title': 'Daily reach per account',
    'chart.reachOverTime.aria': 'Daily reach, one line per account',

    'table.title': 'Accounts in the period',
    'table.account': 'Account',
    'table.alignment': 'Alignment',
    'table.alignment.own': 'Own',
    'table.alignment.adversary': 'Adversary',
    'table.posts': 'Posts',
    'table.reach': 'Reach',
    'table.engagement': 'Engagement',
    'table.targeting': 'Posts against us',
    'table.commentsRead': 'Comments analysed',
    'table.sentiment': 'Average sentiment',
    'table.unknownHandle': 'Account with no handle',
    'table.candidate.unassigned': 'No candidate set',

    'empty.title': 'No adversary account monitored.',
    'empty.description':
      'Mark an account with the Adversary alignment to compare it with the campaign.',

    'error.title': 'Error loading Adversaries',
    'error.description': 'Could not load the accounts’ reading for the period.',
    loading: 'Loading Adversaries...',
  },
);

export const dm = adversariesCatalogue.t;
